import logo from './logo.svg';
import './App.css';
import LandingPage from "./components/lp";

function App() {
  return (
    <LandingPage/>
  );
}

export default App;
